import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterWithdrawalRequests from 'views/financial/withdrawalRequests/filterWithdrawalRequest'; // Importing filter component for withdrawal requests
import TableWithdrawalRequest from 'views/financial/withdrawalRequests/tableWithdrawalRequest'; // Importing table component for withdrawal requests
import DetailsWithdrawalRequest from 'views/financial/withdrawalRequests/detailsWithdrawalRequests'; // Importing details component for withdrawal requests
import RecordWithdrawalRequest from 'views/financial/withdrawalRequests/recordWithdrawalRequest'; // Importing record component for withdrawal requests
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal requests view.
 * @extends JetView
 */
export default class withdrawalRequestsView extends JetView {
    /**
     * Configures the layout of the withdrawal requests view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        const right = {
            // Configuration for the right section of the layout
            type: 'wide',
            minWidth: 400,
            rows: [
                PlayersView, // Including PlayersView in the right section
                RecordWithdrawalRequest, // Including RecordWithdrawalRequest in the right section
                DetailsWithdrawalRequest, // Including DetailsWithdrawalRequest in the right section
            ],
        };

        const toolbar = {
            // Configuration for the toolbar
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetch from configuration
                },
            ],
        };

        const left = {
            // Configuration for the left section of the layout
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Applying the current theme
                    elements: [
                        { view: 'label', label: _('Solicitudes de Retiro') }, // Label for withdrawal requests
                    ],
                },
                FilterWithdrawalRequests, // Including FilterWithdrawalRequests in the left section
                TableWithdrawalRequest, // Including TableWithdrawalRequest in the left section
                toolbar, // Including the toolbar in the left section
            ],
        };

        return {
            // Returning the main configuration object for the view
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Type of the view
            view: 'form', // Main view type
            scroll: 'y', // Enabling vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive configuration
                    type: 'wide', // Type of the row
                    cols: [left, right], // Defining columns with left and right sections
                },
            ],
        };
    }
}

// FILE DOCUMENTED
